import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AIInsights() {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true); setText("");
    try {
      const backendURL = process.env.REACT_APP_BACKEND_URL;
      const res = await fetch(`${backendURL}/api/ai/insights`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("erp_token") || ""}` },
        body: JSON.stringify({}),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        setText(t => t + dec.decode(value, { stream: true }));
      }
    } catch (e) {
      toast.error(formatErr(e));
    } finally { setBusy(false); }
  };

  useEffect(() => { run(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="p-8">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-primary text-xs uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
            <Sparkles className="w-3 h-3"/> Claude Sonnet 4.6
          </div>
          <h1 className="font-display font-black text-4xl uppercase tracking-tighter">AI Insights</h1>
          <div className="text-sm text-muted-foreground mt-2">Auto-generated recommendations from your workshop data</div>
        </div>
        <Button data-testid="regen-ai-btn" onClick={run} disabled={busy} className="rounded-sm bg-primary text-primary-foreground uppercase tracking-[0.15em] font-bold text-xs">
          {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin"/> : <Sparkles className="w-4 h-4 mr-1"/>}
          Regenerate
        </Button>
      </div>

      <div className="border border-border bg-card rounded-sm p-6 min-h-[300px]">
        {!text && busy && (
          <div className="text-muted-foreground flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin"/> Analyzing workshop data...</div>
        )}
        <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed text-foreground">{text}</pre>
      </div>
    </div>
  );
}
